export default __webpack_public_path__ + "static/media/games-rebate-ico.3c83d2e7.svg";